import classNames from "classnames";
import { useState } from "react";
import noImageUrl from "../../assets/images/no_image.png";

// Create the containers interface
interface IProps {
  src: string;
  className?: string;
  onClick?: () => void;
  onError?: () => void;
  alt?: string;
}

function ImageCustom(props: IProps) {
  const { className, src, alt } = props;
  const [isError, setIsError] = useState(false);

  const handleImageErrored = (): void => {
    setIsError(true);
  };

  const url = isError ? noImageUrl : src;

  return (
    <img
      className={classNames('img', className)}
      onClick={props.onClick}
      onError={handleImageErrored}
      src={url}
      alt={alt}
    />
  );
}

export default ImageCustom;
